import * as React from 'react'
import * as TT from '../../components/ChartToolTip'

interface Props {
  unit: string
  headLeft?: string
  headRight?: string
}

export const ToolTip: React.FC<Props> = ({ unit, headLeft, headRight }) => {
  return (
    <TT.Container>
      <TT.TipHead>
        <TT.Left>{headLeft}</TT.Left>
        <TT.Right>{headRight}</TT.Right>
      </TT.TipHead>
      <TT.ValueLabel>CONSUMPTION</TT.ValueLabel>
      <TT.Value>$datavalue <TT.ValueUnit as='span'>{unit}</TT.ValueUnit></TT.Value>
    </TT.Container>
  )
}
